import React, { useState, useEffect } from "react";
import { Box, Typography, Paper, TextField, Stack } from "@mui/material";
import { fetchPolicyData } from "../../../api/fetchPolicyData";
import { updatePolicyData } from "../../../utils/updatePolicyData"; // Import the update function
import LogButton from "./PolicyComponent/LogButton"; // Update import if necessary
import UpdateIcon from "@mui/icons-material/Update";
import UpdateIconDesign from "../../common/UpdateIconQMS";
//
export default function QualityPolicy({ onShowLogs }) {
  const [policyData, setPolicyData] = useState([]); // Store fetched data
  const [policyText, setPolicyText] = useState(""); // Manage the field value
  const [recordId, setRecordId] = useState(""); // Store the record ID

  useEffect(() => {
    const initializeApp = async () => {
      try {
        if (window.ZOHO && ZOHO.embeddedApp) {
          await ZOHO.embeddedApp.init();
          console.log("✅ ZOHO embedded app initialized in QualityPolicy");
        } else {
          console.warn("⚠️ ZOHO embeddedApp not available in QualityPolicy");
          return;
        }

        const data = await fetchPolicyData();
        if (data.length > 0) {
          setPolicyData(data); // Store the fetched data
          setPolicyText(data[0].policyText); // Set the first policy text
          setRecordId(data[0].id); // Store the record ID
        } else {
          console.warn("⚠️ No policy data found");
        }
      } catch (err) {
        console.error("❌ Error initializing QualityPolicy:", err);
      }
    };

    initializeApp();
  }, []);

  const handleTextChange = (e) => {
    setPolicyText(e.target.value); // Update state on user input
  };

  const handleUpdate = async () => {
    if (!recordId) {
      alert("Record ID is missing. Cannot update the policy.");
      return;
    }

    const updateData = {
      Multi_Line: policyText, // Update the policy text field
    };

    const success = await updatePolicyData(recordId, updateData);
    if (success) {
      console.log("✅ Policy updated successfully!");
    }
  };

  const ActionButtons = ({ onShowLogs }) => {
    return (
      <Stack direction="row" spacing={1}>
        <UpdateIconDesign
          sx={{
            minWidth: 80,
            height: 36,
            px: 2,
            py: 0.5,
          }}
          onClick={handleUpdate}
          icon={<UpdateIcon />}
        />
        <LogButton policyData={policyData} />
      </Stack>
    );
  };

  return (
    <Box>
      <Box display="flex" justifyContent="space-between">
        <Typography variant="h6" fontWeight="bold" sx={{ color: "#4F46E5" }}>
          Quality Policy
        </Typography>
        <ActionButtons onShowLogs={onShowLogs} />
      </Box>

      <Box mt={2}>
        <TextField
          id="quality_policy_textfield"
          fullWidth
          multiline
          rows={10}
          variant="outlined"
          value={policyText}
          onChange={handleTextChange} // Handle user input
        />
      </Box>

      {/* Display additional policy data */}
      {policyData.length === 0 && (
        <Typography mt={2}>No policy data available.</Typography>
      )}
    </Box>
  );
}
